// A phone held sideways (CLAUDE.md: Build notes — Phone landscape).
//
// The one query every sideways-only rule is written against: `(max-height:
// 500px)` in the stylesheets, and this for the few things script has to decide —
// where the game header sits, and where the keyboard rule puts the page. A
// portrait phone is at least 568px tall and a landscape one at most 430, so
// nothing real sits near the line.
import { useEffect, useState } from 'react';

export const SIDEWAYS = '(max-height: 500px)';

export const isSideways = (): boolean =>
  typeof window !== 'undefined' && window.matchMedia(SIDEWAYS).matches;

/** Whether the phone is on its side, kept up to date as it is turned. */
export function useSideways(): boolean {
  const [on, setOn] = useState(isSideways);
  useEffect(() => {
    const query = window.matchMedia(SIDEWAYS);
    const update = () => setOn(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return on;
}
